import { render, staticRenderFns } from "./customSearchComponent.vue?vue&type=template&id=288d9b3c&"
import script from "./customSearchComponent.vue?vue&type=script&lang=js&"
export * from "./customSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports